import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
export var getInnerContentLength = function getInnerContentLength(htmlContent) {
  var divElem = document.createElement('div');
  divElem.innerHTML = htmlContent;
  return divElem.innerText.length;
};
export var contentParser = function contentParser(htmlString, maxLength) {
  var contentArray = [];
  var remainderLength = maxLength || 0;

  try {
    do {
      if (/^(<\w+([0-9]+)?(\s+[^<>]+)?>)/.test(htmlString)) {
        var startTag = htmlString.match(/^(<\w+([0-9]+)?(\s+[^<>]+)?>)/);
        var startTagNameMatch = startTag[0].match(/^(<\w+([0-9]+)?)/);
        var startTagName = startTagNameMatch[0].replace('<', '');
        var endTagRegex = new RegExp("</".concat(startTagName, ">"));
        var endTag = htmlString.match(endTagRegex);
        var contentStr = htmlString.slice(startTag.index + startTag[0].length, endTag ? endTag.index : undefined);
        var content = contentParser(contentStr, remainderLength);
        contentArray.push({
          tag: startTag[0],
          tagName: startTagName,
          contentStr: contentStr,
          content: content
        });
        remainderLength = remainderLength - getInnerContentLength(contentStr);

        if (remainderLength > 0) {
          if (endTag) {
            htmlString = htmlString.slice(endTag.index + endTag[0].length);
          } else {
            return false;
          }
        } else {
          remainderLength = 0;
          htmlString = '';
        }
      } else if (/<\w+([0-9]+)?(\s+[^<>]+)?>/.test(htmlString)) {
        var _startTag = htmlString.match(/<\w+([0-9]+)?(\s+[^<>]+)?>/);

        var _contentStr = htmlString.slice(0, _startTag.index);

        contentArray.push({
          tag: null,
          tagName: null,
          contentStr: _contentStr.length < remainderLength ? _contentStr : htmlString.slice(0, remainderLength) + '...',
          content: null
        });

        if (_contentStr.length < remainderLength) {
          remainderLength = remainderLength - _contentStr.length;
          htmlString = htmlString.slice(_startTag.index);
        } else {
          remainderLength = 0;
          htmlString = '';
        }
      } else {
        contentArray.push({
          tag: null,
          tagName: null,
          contentStr: htmlString.length < remainderLength ? htmlString : htmlString.slice(0, remainderLength) + '...',
          content: null
        });
        remainderLength = remainderLength - htmlString.length > 0 ? remainderLength - htmlString.length : 0;
        htmlString = '';
      }
    } while (htmlString && htmlString.length > 0 && remainderLength);
  } catch (error) {
    console.log('Error --> contentParser', error);
    return false;
  }

  return contentArray;
};
export var contentReplaceLink = function contentReplaceLink(htmlString) {
  var str = htmlString;
  var linkRegex = /<a.+<\/a>/g;
  var linkMatchList = str.match(linkRegex);

  if (linkMatchList) {
    linkMatchList.forEach(function (z) {
      var _linkRegex = /<a.+">/g;

      var _linkMatch = z.match(_linkRegex);

      var _linkReplace = z.replace(_linkMatch[0], _linkMatch[0].slice(0, -1) + ' target="_blank">');

      str = str.replace(z, _linkReplace);
    });
  }

  return str;
};